import React, { useState } from "react";

// Small inline icons so we don't depend on extra icon packages.
function EyeIcon({ className = "", ...props }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`h-4 w-4 ${className}`}
      aria-hidden="true"
      {...props}
    >
      <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

function EyeOffIcon({ className = "", ...props }) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`h-4 w-4 ${className}`}
      aria-hidden="true"
      {...props}
    >
      <path d="M3 3l18 18" />
      <path d="M10.58 10.58A3 3 0 0 0 12 15a3 3 0 0 0 2.42-4.42" />
      <path d="M9.88 5.08A10.6 10.6 0 0 1 12 5c6.5 0 10 7 10 7a19.9 19.9 0 0 1-4.21 5.25" />
      <path d="M6.1 6.1C3.86 7.73 2 10.2 2 12s3.5 7 10 7c1.02 0 1.99-.16 2.9-.45" />
    </svg>
  );
}

export default function RegistrationSection({ api }) {
  const {
    Dropdown,
    registration,
    registrationStatus,
    handleRegistrationSubmit,
    setRegistration,
    paymentPlanOptions,
    t,
  } = api || {};

    const [showPass, setShowPass] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [localError, setLocalError] = useState("");

  const requiresAdultAuth = ['Babys','Toddler','Teens','Young Adults'].includes(String(registration?.ageRange || '').trim());

  const fileToBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        const s = String(reader.result || '');
        const b64 = s.includes(',') ? s.split(',')[1] : s;
        resolve({
          filename: file.name,
          content: b64,
          type: file.type || 'application/octet-stream',
        });
      };
      reader.onerror = () => reject(reader.error);
      reader.readAsDataURL(file);
    });


const title = (t && t.nav && t.nav.registration) || "Registration";
  const L = (t && t.earlyAccess) || {};

  return (
    <section id="registration" className="space-y-4">
      <h2 className="text-2xl sm:text-3xl font-semibold text-emerald-300">
        {title}
      </h2>

      <p className="text-sm sm:text-base text-slate-200 max-w-4xl">
        {L.description ||
          "Enter your information to receive updates as legal, banking, and compliance structures finalize."}
      </p>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          setLocalError("");
          if (requiresAdultAuth) {
            if (!registration.adultProof) {
              setLocalError("Adult authorization (required for minors) is required for minors.");
              return;
            }
            if (!registration.adultIdFiles || registration.adultIdFiles.length === 0) {
              setLocalError("Please attach the adult ID.");
              return;
            }
          }
          handleRegistrationSubmit(e);
        }}
        className="rounded-3xl border border-slate-800/70 bg-[#010916]/85 p-6 space-y-4"
      >
        <div className="grid gap-4 md:grid-cols-2">
          <div>
            <div className="text-xs text-slate-300 mb-2">
              {L.firstName || "First Name"}
            </div>
            <input
              name="firstName"
              value={registration.firstName}
              onChange={(e) =>
                setRegistration((p) => ({ ...p, firstName: e.target.value }))
              }
              className="w-full rounded-xl bg-[#010916]/90 border border-slate-700 px-3 py-2 text-sm text-slate-100 focus:outline-none focus:border-emerald-400"
              required
            />
          </div>

          <div>
            <div className="text-xs text-slate-300 mb-2">
              {L.lastName || "Last Name"}
            </div>
            <input
              name="lastName"
              value={registration.lastName}
              onChange={(e) =>
                setRegistration((p) => ({ ...p, lastName: e.target.value }))
              }
              className="w-full rounded-xl bg-[#010916]/90 border border-slate-700 px-3 py-2 text-sm text-slate-100 focus:outline-none focus:border-emerald-400"
              required
            />
          </div>

          <div>
            <div className="text-xs text-slate-300 mb-2">
              {L.email || "Email Address"}
            </div>
            <input
              type="email"
              name="email"
              value={registration.email}
              onChange={(e) =>
                setRegistration((p) => ({ ...p, email: e.target.value }))
              }
              className="w-full rounded-xl bg-[#010916]/90 border border-slate-700 px-3 py-2 text-sm text-slate-100 focus:outline-none focus:border-emerald-400"
              required
            />
          </div>

          <div>
            <div className="text-xs text-slate-300 mb-2">
              {L.address || "Address"}
            </div>
            <input
              name="address"
              value={registration.address}
              onChange={(e) =>
                setRegistration((p) => ({ ...p, address: e.target.value }))
              }
              className="w-full rounded-xl bg-[#010916]/90 border border-slate-700 px-3 py-2 text-sm text-slate-100 focus:outline-none focus:border-emerald-400"
            />
          </div>
	        </div>

        {/* Account setup (moved from modal) */}
        <div className="grid gap-4">
          <div className="grid gap-4 md:grid-cols-3">
            <div>
              <div className="text-xs text-slate-300 mb-2">
                {(t && t.auth && t.auth.username) || "Username"}
              </div>
              <input
                name="username"
                value={registration.username || ""}
                onChange={(e) =>
                  setRegistration((p) => ({ ...p, username: e.target.value }))
                }
                className="w-full rounded-xl bg-[#010916]/90 border border-slate-700 px-3 py-2 text-sm text-slate-100 focus:outline-none focus:border-emerald-400"
                required
              />
            </div>

            <div>
              <div className="text-xs text-slate-300 mb-2">
                {(t && t.auth && t.auth.plan) || "Plan"}
              </div>
              <select
                className="w-full rounded-xl bg-[#010916]/90 border border-slate-700 px-3 py-2 text-sm text-slate-100 focus:outline-none focus:border-emerald-400"
                value={registration.plan || paymentPlanOptions?.find((p) => !p.disabled)?.value || ""}
                onChange={(e) =>
                  setRegistration((p) => ({ ...p, plan: e.target.value }))
                }
              >
                {(paymentPlanOptions || []).map((p) => (
                  <option key={p.value} value={p.value} disabled={!!p.disabled}>
                    {p.label}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <div className="text-xs text-slate-300 mb-2">
                {(t && t.auth && t.auth.billingFrequency) || "Billing Frequency"}
              </div>
              <select
                className="w-full rounded-xl bg-[#010916]/90 border border-slate-700 px-3 py-2 text-sm text-slate-100 focus:outline-none focus:border-emerald-400"
                value={registration.billingFrequency || "monthly"}
                onChange={(e) =>
                  setRegistration((p) => ({
                    ...p,
                    billingFrequency: e.target.value,
                  }))
                }
              >
                <option value="monthly">Monthly</option>
                <option value="yearly">Yearly</option>
                <option value="one-time">One-time</option>
              </select>
            </div>
          </div>

          <div className="grid gap-4 md:grid-cols-2">
            <div>
              <div className="text-xs text-slate-300 mb-2">
                {(t && t.auth && t.auth.password) || "Password"}
              </div>
              <div className="relative">
                <input
                  type={showPass ? "text" : "password"}
                  name="password"
                  value={registration.password || ""}
                  onChange={(e) =>
                    setRegistration((p) => ({ ...p, password: e.target.value }))
                  }
                  className="w-full rounded-xl bg-[#010916]/90 border border-slate-700 px-3 py-2 pr-10 text-sm text-slate-100 focus:outline-none focus:border-emerald-400"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowPass((s) => !s)}
                  className="absolute right-2 top-1/2 -translate-y-1/2 rounded-lg border border-slate-700 bg-[#010916]/70 p-2 text-slate-200 hover:border-emerald-400 hover:text-emerald-300 focus:outline-none focus:ring-2 focus:ring-emerald-400/40"
                  aria-label={showPass ? "Hide password" : "Show password"}
                  title={showPass ? "Hide" : "Show"}
                >
                  {showPass ? <EyeOffIcon /> : <EyeIcon />}
                </button>
              </div>
            </div>

            <div>
              <div className="text-xs text-slate-300 mb-2">
                {(t && t.auth && t.auth.confirmPassword) || "Confirm password"}
              </div>
              <div className="relative">
                <input
                  type={showConfirm ? "text" : "password"}
                  name="confirmPassword"
                  value={registration.confirmPassword || ""}
                  onChange={(e) =>
                    setRegistration((p) => ({
                      ...p,
                      confirmPassword: e.target.value,
                    }))
                  }
                  className="w-full rounded-xl bg-[#010916]/90 border border-slate-700 px-3 py-2 pr-10 text-sm text-slate-100 focus:outline-none focus:border-emerald-400"
                  required
                />
                <button
                  type="button"
                  onClick={() => setShowConfirm((s) => !s)}
                  className="absolute right-2 top-1/2 -translate-y-1/2 p-2 rounded-lg border border-slate-700 bg-[#010916]/70 text-slate-200 hover:text-emerald-300 hover:border-emerald-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/40"
                  aria-label={showConfirm ? "Hide confirm password" : "Show confirm password"}
                  title={showConfirm ? "Hide" : "Show"}
                >
                  {showConfirm ? <EyeOffIcon /> : <EyeIcon />}
                </button>
              </div>
            </div>
          </div>

        <div>
          <div className="text-xs text-slate-300 mb-2">
            {L.ageRange || "Age Range"}
          </div>
          <Dropdown
            value={registration.ageRange}
            onChange={(v) => setRegistration((p) => ({ ...p, ageRange: v }))}
            placeholder="Select age range"
            options={[
              { label: "Babys", value: "Babys" },
              { label: "Toddler", value: "Toddler" },
              { label: "Teens", value: "Teens" },
              { label: "Young Adults", value: "Young Adults" },
              { label: "Adults", value: "Adults" },
              { label: "Seniors", value: "Seniors" },
            ]}
          />
        </div>
        {requiresAdultAuth && (
          <div className="mt-2 rounded-2xl border border-slate-800/70 bg-[#010916]/70 p-4">
            <div className="flex items-start gap-3">
              <input
                type="checkbox"
                checked={!!registration.adultProof}
                onChange={(e) =>
                  setRegistration((p) => ({ ...p, adultProof: e.target.checked }))
                }
                className="mt-1 h-4 w-4 accent-emerald-400"
              />
              <div className="text-xs text-slate-200">
                <div className="font-semibold text-slate-100">
                  Adult authorization (required for minors)
                </div>
                <div className="mt-1 text-slate-300">
                  If the applicant is under 18, a parent/guardian must authorize the signup and upload a valid adult ID.
                  (We store filenames + email only.)
                </div>
              </div>
            </div>

            {registration.adultProof && (
              <div className="mt-3">
                <div className="text-xs text-slate-300 mb-2">Adult ID (required)</div>
                <input
                  type="file"
                  accept="image/*,.pdf"
                  onChange={(e) => {
                    const files = Array.from(e.target.files || []);
                    setRegistration((p) => ({
                      ...p,
                      adultIdFiles: files.map((f) => f.name),
                      adultIdUploads: [],
                    }));
                    Promise.all(files.map(fileToBase64))
                      .then((uploads) => {
                        setRegistration((p) => ({
                          ...p,
                          adultIdUploads: uploads,
                        }));
                      })
                      .catch(() => {});
                  }}
                  className="w-full rounded-xl bg-[#010916]/90 border border-slate-700 px-3 py-2 text-sm text-slate-100"
                />
                <div className="mt-2 text-xs text-slate-400">
                  Selected: {(registration.adultIdFiles || []).join(", ") || "None"}
                </div>
              </div>
            )}
          </div>
        )}


        <div className="text-xs text-slate-300">
          {L.orgLine ||
            "We are a humanitarian and research organization — please provide city/parish, state/providence, country, region, and ZIP code."}
        </div>

        <div className="grid gap-4 md:grid-cols-2">
          <div>
            <div className="text-xs text-slate-300 mb-2">
              {L.cityParish || "City / Parish"}
            </div>
            <input
              name="cityParish"
              value={registration.cityParish}
              onChange={(e) =>
                setRegistration((p) => ({ ...p, cityParish: e.target.value }))
              }
              className="w-full rounded-xl bg-[#010916]/90 border border-slate-700 px-3 py-2 text-sm text-slate-100 focus:outline-none focus:border-emerald-400"
            />
          </div>

          <div>
            <div className="text-xs text-slate-300 mb-2">
              {L.stateProvince || "State / Providence"}
            </div>
            <input
              name="stateProvince"
              value={registration.stateProvince}
              onChange={(e) =>
                setRegistration((p) => ({
                  ...p,
                  stateProvince: e.target.value,
                }))
              }
              className="w-full rounded-xl bg-[#010916]/90 border border-slate-700 px-3 py-2 text-sm text-slate-100 focus:outline-none focus:border-emerald-400"
            />
          </div>

          <div>
            <div className="text-xs text-slate-300 mb-2">
              {L.country || "Country"}
            </div>
            <input
              name="country"
              value={registration.country}
              onChange={(e) =>
                setRegistration((p) => ({ ...p, country: e.target.value }))
              }
              className="w-full rounded-xl bg-[#010916]/90 border border-slate-700 px-3 py-2 text-sm text-slate-100 focus:outline-none focus:border-emerald-400"
            />
          </div>

          <div>
            <div className="text-xs text-slate-300 mb-2">
              {L.region || "Region"}
            </div>
            <input
              name="region"
              value={registration.region}
              onChange={(e) =>
                setRegistration((p) => ({ ...p, region: e.target.value }))
              }
              className="w-full rounded-xl bg-[#010916]/90 border border-slate-700 px-3 py-2 text-sm text-slate-100 focus:outline-none focus:border-emerald-400"
            />
          </div>

          <div>
            <div className="text-xs text-slate-300 mb-2">
              {L.zip || "ZIP / Postal Code"}
            </div>
            <input
              name="zip"
              value={registration.zip}
              onChange={(e) =>
                setRegistration((p) => ({ ...p, zip: e.target.value }))
              }
              className="w-full rounded-xl bg-[#010916]/90 border border-slate-700 px-3 py-2 text-sm text-slate-100 focus:outline-none focus:border-emerald-400"
            />
          </div>
        </div>

        <div>
          <div className="text-xs text-slate-300 mb-2">
            {L.useLabel || "How would you like to use WOW50/50?"}
          </div>
          <textarea
            name="use"
            value={registration.use}
            onChange={(e) =>
              setRegistration((p) => ({ ...p, use: e.target.value }))
            }
            rows={3}
            className="w-full rounded-2xl bg-[#010916]/90 border border-slate-700 px-3 py-2 text-sm text-slate-100 focus:outline-none focus:border-emerald-400"
            placeholder={
              L.usePlaceholder ||
              "For example: fundraising for a program, building personal savings, volunteering, marketplace access, etc."
            }
          />
        </div>

        <label className="flex items-start gap-3 text-sm text-slate-200">
          <input
            type="checkbox"
            checked={!!registration.permission}
            onChange={(e) =>
              setRegistration((p) => ({ ...p, permission: e.target.checked }))
            }
            className="mt-1"
          />
          <span>
            {L.permission ||
              "I give WOW50/50 permission to share my information for other benefits, discounts, opportunities, and privileged timely information (when available)."}
          </span>
        </label>

        {/* Attachments (optional) */}
        <div className="rounded-2xl border border-slate-700 bg-slate-950/40 p-4">
          <div className="text-sm font-semibold text-slate-100">
            {L.attachmentsTitle || "Attachments (optional)"}
          </div>
          <div className="mt-1 text-xs text-slate-300">
            {L.attachmentsDesc ||
              "Upload documents or images. We save filenames + email filenames."}
          </div>

          <input
            className="mt-3 block w-full text-sm text-slate-200 file:mr-4 file:rounded-full file:border file:border-emerald-400/60 file:bg-emerald-500/10 file:px-4 file:py-2 file:text-emerald-200 hover:file:bg-emerald-500/15"
            type="file"
            multiple
            accept="image/*,application/pdf"
            onChange={(e) => {
              const files = Array.from(e.target.files || []);
              setRegistration((p) => ({
                ...p,
                attachments: files.map((f) => f.name),
              }));
            }}
          />
        </div>

	      </div>

	        {/* Consent (required) */}
        <label className="flex items-start gap-3 text-sm text-slate-200">
          <input
            type="checkbox"
            required
            checked={!!registration.consent}
            onChange={(e) =>
              setRegistration((p) => ({ ...p, consent: e.target.checked }))
            }
            className="mt-1"
          />
          <span>
            {L.consentText ||
              "I confirm the information is accurate and I consent to be contacted by WOW50/50."}
          </span>
        </label>

        <div className="flex flex-wrap items-center gap-3">
          <button
            type="submit"
            disabled={registrationStatus === "loading"}
            className="rounded-2xl border border-emerald-500/60 bg-emerald-500/10 px-4 py-2 text-sm text-emerald-300 hover:border-emerald-400 disabled:opacity-60"
          >
            {registrationStatus === "loading" ? "Redirecting…" : ((t && t.registration && t.registration.continueToCheckout) || "Continue to Checkout")}
          </button>

          {registrationStatus === "success" && (
            <span className="text-xs text-emerald-300">
              {L.success || "Submitted. Thank you!"}
            </span>
          )}
          {registrationStatus === "error" && (
            <span className="text-xs text-rose-300">
              {L.error || "Submit failed. Try again."}
            </span>
          )}
          {localError && (
            <span id="reg-local-error" className="text-xs text-rose-300">
              {localError}
            </span>
          )}
        </div>
      </form>
    </section>
  );
}
